// Invalid HTTP Header chars, borrowed from node
// https://github.com/nodejs/node/blob/862389b0aacfd41770c3fa6f692aed11c2a4b3ed/lib/_http_common.js#L245
const headerCharRegex = /[^\t\x20-\x7e\x80-\xff]/;

// Ignore any non-valid HTTP header values
export default function valueFromHeader(value) {
  if (value && !headerCharRegex.test(value)) {
    return value;
  }
  return undefined;
}
